import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import ReservationPlansIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/reservation-plans'),
      component: SettingsContent,
      props: {
        headerTitle: '',
        showBackButton: false,
      },
      children: [
        {
          path: '',
          name: 'reservation_plans_index',
          component: ReservationPlansIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
